export enum ResourceAllowOrderForm {
    Allow = 0,
    LightResource = 1,
    ChildVR = 2,
    DifferentSOF = 3,
    Tentative = 4,
    IsRecurring =5,
    Denied = 6,
    Workspace = 7
}